<div (click)="onViewClick()"
  class="grid grid-cols-11 gap-4 px-5 py-3.5 border-b border-slate-100 dark:border-slate-700/50 hover:bg-blue-50/40 hover:shadow-[inset_3px_0_0_#0D76BA] transition-all duration-150 items-center cursor-pointer group">

  <!-- Date -->
  <div class="col-span-1 text-left">
    <p class="text-[11px] font-bold text-slate-700 dark:text-slate-300 uppercase">{{ repayment().date | date:'d MMM' }}</p>
    <p class="text-[10px] text-slate-400 font-medium">{{ repayment().date | date:'yyyy' }}</p>
  </div>

  <!-- Transaction ID -->
  <div class="col-span-1 text-left">
    <p class="text-[10px] font-mono text-slate-500 dark:text-slate-400 truncate" [title]="repayment().transactionId">{{ repayment().transactionId }}</p>
  </div>

  <!-- Applicant -->
  <div class="col-span-1 flex items-center justify-start gap-2 min-w-0">
    <div class="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 text-white text-[9px] font-bold bg-primary-800">{{ initials }}</div>
    <p class="text-xs font-bold text-slate-900 dark:text-white truncate group-hover:text-primary-800 dark:text-primary-400 transition-colors">{{ applicantName }}</p>
  </div>

  <!-- Loan Reference -->
  <div class="col-span-1 min-w-0 text-left">
    <p class="text-[10px] font-mono text-slate-500 dark:text-slate-400 truncate" [title]="repayment().loan.reference || ''">{{ repayment().loan.reference || '—' }}</p>
  </div>

  <!-- Loan Amount -->
  <div class="col-span-1 text-left">
    <p class="text-[11px] font-bold text-slate-900 dark:text-white">₵{{ repayment().loan.amount ?? repayment().loan.principal_amount | number:'1.2-2' }}</p>
  </div>

  <!-- Interest Rate -->
  <div class="col-span-1 text-left">
    <p class="text-[11px] font-semibold text-slate-600 dark:text-slate-400">{{ repayment().loan.interestRate }}%</p>
  </div>

  <!-- Monthly Repayment -->
  <div class="col-span-1 text-left">
    <p class="text-[11px] font-semibold text-slate-700 dark:text-slate-300">₵{{ repayment().loan.monthlyRepayment | number:'1.2-2' }}</p>
  </div>

  <!-- Amount Paid -->
  <div class="col-span-1 text-left">
    <p class="text-[11px] font-bold text-emerald-600">₵{{ +repayment().amount | number:'1.2-2' }}</p>
  </div>

  <!-- Type -->
  <div class="col-span-1 flex justify-start">
    @if (repayment().type === 'BANK') {
    <span class="inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-bold bg-blue-50 dark:bg-blue-950/40 text-blue-600 dark:text-blue-400 border border-blue-100 dark:border-blue-900 uppercase tracking-wider leading-none">Bank</span>
    } @else if (repayment().type === 'MOMO') {
    <span class="inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-bold bg-amber-50 dark:bg-amber-950/40 text-amber-600 dark:text-amber-400 border border-amber-100 dark:border-amber-900 uppercase tracking-wider leading-none">MoMo</span>
    } @else if (repayment().type === 'CASH') {
    <span class="inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-bold bg-emerald-50 dark:bg-emerald-950/40 text-emerald-600 dark:text-emerald-400 border border-emerald-100 dark:border-emerald-900 uppercase tracking-wider leading-none">Cash</span>
    } @else {
    <span class="text-[10px] text-slate-400">—</span>
    }
  </div>

  <!-- Status -->
  <div class="col-span-1 flex justify-start">
    @if (loanStatus === 'overdue' || loanStatus === 'defaulted') {
    <span class="inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-bold bg-rose-50 dark:bg-rose-950/40 text-rose-600 dark:text-rose-400 border border-rose-100 dark:border-rose-900 uppercase tracking-wider leading-none">
      <span class="w-1 h-1 rounded-full bg-rose-500 inline-block"></span>{{ repayment().loan.status }}
    </span>
    } @else if (loanStatus === 'completed') {
    <span class="inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-bold bg-purple-50 dark:bg-purple-950/40 text-purple-600 dark:text-purple-400 border border-purple-100 dark:border-purple-900 uppercase tracking-wider leading-none">
      <span class="w-1 h-1 rounded-full bg-purple-500 inline-block"></span>Completed
    </span>
    } @else {
    <span class="inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-bold bg-emerald-50 dark:bg-emerald-950/40 text-emerald-600 dark:text-emerald-400 border border-emerald-100 dark:border-emerald-900 uppercase tracking-wider leading-none">
      <span class="w-1 h-1 rounded-full bg-emerald-500 inline-block"></span>{{ repayment().loan.status || 'Active' }}
    </span>
    }
  </div>

  <!-- Actions -->
  <div class="col-span-1 flex justify-center items-center gap-1.5">
    @if (permissionService.canDeleteRepayment()) {
    <button (click)="triggerDelete($event)"
      class="p-1.5 rounded text-rose-500 hover:text-rose-700 hover:bg-rose-50 transition-colors"
      title="Delete">
      <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
      </svg>
    </button>
    }
  </div>
</div>
